import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import i18n from '@/i18n';
import {
  courseAppearanceService,
  type PageSection,
} from '@/services/course-appearance.service';
import { appearanceKeys } from './queryKeys';

/** Delete a section optimistically. */
export function useDeletePageSection(productId: string) {
  const qc = useQueryClient();
  const key = appearanceKeys.sections(productId);

  return useMutation({
    mutationFn: (sectionId: string) =>
      courseAppearanceService.deletePageSection(productId, sectionId),
    onMutate: async (sectionId) => {
      await qc.cancelQueries({ queryKey: key });
      const prev = qc.getQueryData<PageSection[]>(key);
      if (prev) {
        qc.setQueryData<PageSection[]>(
          key,
          prev.filter((s) => s.id !== sectionId),
        );
      }
      return { prev };
    },
    onError: (_e, _v, ctx) => {
      if (ctx?.prev) qc.setQueryData(key, ctx.prev);
      toast.error(i18n.t('adminAppearance:toasts.deleteSectionError'));
    },
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  });
}
